<template>
    <div style="padding: 2em;">
        <basic-card>
            <template v-slot:header>User preferences</template>
            <form-wrapper form-title="Formatting">
                <form-text-input v-model="preferencesId" caption="Preferences ID" disabled/>
                <form-text-input v-model="preferences.defaultNumberSeparator" caption="Default decimals separator"/>
                <form-text-input v-model="preferences.defaultThousandSeparator" caption="Default thousand separator"/>
            </form-wrapper>
            <form-wrapper form-title="Decimal places">
                <form-text-input v-model="preferences.defaultDecimalPlaces" caption="Default decimal places"/>
                <form-text-input v-model="preferences.cashFlowDecimalPlaces" caption="CF decimal places"/>
<!--                <form-text-input v-model="preferences.operationDecimalPlaces" caption="Operation decimal places"/>-->
<!--                <form-text-input v-model="preferences.marketDataDecimalPlaces" caption="Market data decimal places"/>-->
                <!--                <form-text-input v-model="preferences.cashFlowDecimalSeparator" caption="CF decimals separator"/>-->
                <!--                <form-text-input v-model="preferences.cashFlowThousandSeparator" caption="CF thousand separator"/>-->
            </form-wrapper>
            <simple-button @press="savePreferences">Save preferences</simple-button>
        </basic-card>
    </div>
</template>

<script>
import BasicCard from "@/components/layout/BasicCard";
import SimpleLayout from "@/components/layout/SimpleLayout";
import FramedContent from "@/components/layout/FramedContent";
import FormWrapper from "@/components/form/FormWrapper";
import FormTextInput from "@/components/form/FormTextInput";
import SimpleButton from "@/components/button/SimpleButton";

const emptyPreference = () => ({
    defaultDecimalPlaces: 1,
    defaultNumberSeparator: ".",
    defaultThousandSeparator: " ",

    cashFlowDecimalPlaces: 2,
    operationDecimalPlaces: 2,
    marketDataDecimalPlaces: 2,
})


export default {
    name: "UserSettingsView",
    components: {SimpleButton, FormTextInput, FormWrapper, FramedContent, SimpleLayout, BasicCard},
    data: function () {
        return {
            preferencesId: null,
            preferences: emptyPreference()
        }
    },
    methods: {
        async savePreferences() {
            const currentUser = this.$store.getters["auth/actualPrincipal"];
            const preferences = {
                id: this.preferencesId,
                username: currentUser.username,
                preferences: this.$_.cloneDeep(this.preferences)
            }

            await this.$store.dispatch("userPreferences/SAVE_PREFERENCES", preferences);
            await this.reloadPreferences();
        },
        async reloadPreferences() {
            const currentUser = this.$store.getters["auth/actualPrincipal"];
            await this.$store.dispatch("userPreferences/FETCH_PREFERENCES", currentUser);
            const preferences = this.$store.state['userPreferences'].preferences;
            this.preferencesId = preferences.id;
            this.preferences = this.$_.cloneDeep(preferences.preferences);
        }
    },
    async mounted() {
        await this.reloadPreferences();
    }
}
</script>

<style scoped>

</style>